import { Box, Breadcrumbs, Typography, Link as MUILink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useEasierTheme } from "datalign-themes";
import { capitalize } from "lodash";
import React from "react";

const NTBreadcrumb = ({
  domain,
  datatype,
  group,
  input,
}: {
  domain: string | null;
  datatype: string | null;
  group: string | null;
  input?: string | null;
}) => {
  const theme = useEasierTheme();

  return (
    <Box mt={1} py={1} sx={{ width: "100%", maxWidth: "95vw" }}>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={
          <Typography
            sx={{
              color: theme?.Colour.Secondary(),
            }}
          >
            {">"}
          </Typography>
        }
        sx={{
          borderRadius: "12px",
        }}
      >
        <MUILink
          component={RouterLink}
          to="/"
          underline="hover"
          sx={{
            wordWrap: "break-word",
          }}
        >
          Home
        </MUILink>
        {domain && (
          <MUILink
            component={RouterLink}
            to={`/search?Domains=${domain}`}
            underline="hover"
            sx={{
              wordWrap: "break-word",
            }}
          >
            {capitalize(domain)}
          </MUILink>
        )}
        {datatype && (
          <MUILink
            component={RouterLink}
            to={`/search?Datatypes=${datatype}`}
            underline="hover"
            sx={{
              wordWrap: "break-word",
            }}
          >
            {capitalize(datatype)}
          </MUILink>
        )}
        {group && (
          <MUILink
            component={RouterLink}
            to={`/search?Groups=${group}`}
            underline="hover"
            sx={{
              wordWrap: "break-word",
            }}
          >
            {capitalize(group)}
          </MUILink>
        )}
        {input && <Typography>{input}</Typography>}
      </Breadcrumbs>
    </Box>
  );
};

export default NTBreadcrumb;
